import { useState, useEffect, useCallback } from "react";
import { useLanguage } from "./LanguageContext";

export default function Countdown({ targetDate }) {
  const { t } = useLanguage();

  const getTimeLeft = useCallback(() => {
    const diff = new Date(targetDate) - new Date();
    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  }, [targetDate]);

  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, [getTimeLeft]);

  const units = [
    { label: t.days, value: timeLeft.days },
    { label: t.hours, value: timeLeft.hours },
    { label: t.minutes, value: timeLeft.minutes },
    { label: t.seconds, value: timeLeft.seconds },
  ];

  return (
    <section id="countdown" style={{
      padding: "80px 20px",
      textAlign: "center",
      background: "white",
    }}>
      <p style={{
        letterSpacing: "3px",
        textTransform: "uppercase",
        fontSize: "0.85rem",
        color: "var(--blue-400)",
        marginBottom: "8px",
      }}>
        {t.countdownSave}
      </p>

      <h2 className="section-heading">{t.countdownHeading}</h2>

      <div className="divider-ornament" style={{ marginBottom: "40px" }}>
        <span style={{ color: "var(--gold)" }}></span>
      </div>

      <div style={{
        display: "flex",
        justifyContent: "center",
        gap: "16px",
        flexWrap: "wrap",
        maxWidth: "600px",
        margin: "0 auto",
      }}>
        {units.map(({ label, value }) => (
          <div key={label} className="countdown-card" style={{ flex: "1 1 120px", maxWidth: "140px" }}>
            <div style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "2.8rem",
              fontWeight: 700,
              color: "white",
              lineHeight: 1,
              marginBottom: "4px",
            }}>
              {String(value).padStart(2, "0")}
            </div>
            <div style={{
              fontSize: "0.75rem",
              textTransform: "uppercase",
              letterSpacing: "2px",
              color: "rgba(255,255,255,0.7)",
            }}>
              {label}
            </div>
          </div>
        ))}
      </div>

      <p style={{
        marginTop: "32px",
        fontFamily: "'Playfair Display', serif",
        fontStyle: "italic",
        fontSize: "1.1rem",
        color: "var(--blue-600)",
      }}>
        {t.countdownDate}
      </p>
    </section>
  );
}
